import React from 'react';
import './cta-banner.scss';
import esriStrings from '../../resources/esriStrings';
import CtaButton from '../bitsnbobs/ctaButton'

const CtaBanner = (props) =>
  <div className="cta-wrapper">
    <div className="cta-container">
      <span className="cta-text">{esriStrings.ctaBannerText}</span>
      {/* <a
        href="oneform://ArcGIS_-_Promotions_-_Awareness:_Gartner_Showcase_App:_LPG-ov"
        className="cta-button btn btn-large"
      >
        {esriStrings.ctaButtonText}
      </a> */}
      <CtaButton formVisible = {props.formVisible} showForm = {props.showForm}></CtaButton>
    </div>
  </div>
;
export default CtaBanner;
